// extracted by mini-css-extract-plugin
module.exports = {"grid":"O5_8m","header":"szeV9","specifications":"_2qy0U","remove":"Nfcz3"};